import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * AnalyticsTracker — sends a virtual page_view to GA4 on each client-side
 * navigation. Requires `window.gtag` (loaded by CookieConsent when a
 * REACT_APP_GA_ID is set). Silently no-ops otherwise.
 */
const GA_ID = process.env.REACT_APP_GA_ID;

export const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (!GA_ID || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);
  return null;
};
